import * as types from '../actionTypes';

export function setDomain(domain) {
    return { type: types.SET_DOMAIN, data: domain };
}

export function clearDomain() {
    return { type: types.CLEAR_DOMAIN };
}